import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HighchartsExporting from 'highcharts/modules/exporting'
import highchartsAccessibility from 'highcharts/modules/accessibility'
import { useEffect, useRef, useState } from 'react'
import NoDataImage from '../../../common/components/NoDataImage'

HighchartsExporting(Highcharts)
highchartsAccessibility(Highcharts)

Highcharts.setOptions({
  chart: {
    style: {
      fontFamily: '"Open Sans", sansSerif',
    },
  },
})

const LineChart = ({
  chartKey,
  chartOptions,
  noDataImageURL,
  selectedCountries,
  selectedAverages,
  setLegendRefFalse,
  uniqueKey,
}) => {
  const chartRef = useRef(null)
  const [noData, setNoData] = useState(false)

  useEffect(() => {
    // Cleanup function to destroy the chart when the component unmounts
    return () => {
      if (chartRef.current) {
        chartRef.current.chart.destroy()
      }
    }
  }, [uniqueKey])

  useEffect(() => {
    const noData =
      chartOptions?.series?.length === 0 ||
      chartOptions?.series?.every((item) => item?.data?.length === 0)
    setLegendRefFalse(noData)
    setNoData(noData)
  }, [chartOptions])

  return (
    <div className="tui__chart_content">
      {!noData && chartOptions ? (
        <div>
          <figure className="highcharts-figure" id={uniqueKey}>
            <HighchartsReact
              ref={chartRef}
              key={`highcharts-${chartKey}-${JSON.stringify(
                chartOptions?.series
              )}-${uniqueKey}`}
              highcharts={Highcharts}
              options={chartOptions}
            />
          </figure>
        </div>
      ) : (
        <>
          {selectedCountries.length === 0 &&
          selectedAverages &&
          selectedAverages.length === 0 ? (
            <div
              className="no-data-msg no-data-text"
            >
              <p>Select a country or economy to view data</p>
            </div>
          ) : (
            <NoDataImage
              imageURL={noDataImageURL}
              height="345px"
              width="100%"
            />
          )}
        </>
      )}
    </div>
  )
}
export default LineChart
